import React from 'react';
import { TaskCard } from './TaskCard';
import { TaskMeta } from './TaskMeta';
import { TaskTypeChip } from './TaskTypeChip';
import { taskPath, taskQuantityText, taskTitle } from '../../../features/operatorTasks/operatorTasksUtils';

/**
 * A task of the tray, numbered by its place in it, that opens where it is
 * worked.
 *
 * @param {object} props
 * @param {object} props.task
 * @param {number} props.position - Its place in the tray, «Siguiente» being the first.
 */
export const TaskRow = ({ task, position }) => (
  <TaskCard
    to={taskPath(task)}
    testId="task-row"
    data={{
      'data-position': position,
      'data-task-id': task.id,
      'data-type': task.type,
      'data-in-progress': String(Boolean(task.in_progress)),
      'data-waiting-stock': String(Boolean(task.waiting_stock)),
    }}
    title={
      <>
        <span className="mr-2 text-text-muted">{position}.</span>
        {taskTitle(task)}
      </>
    }
    subtitle={[task.company?.name, taskQuantityText(task)].filter(Boolean).join(' · ')}
  >
    <TaskMeta task={task}>
      <TaskTypeChip type={task.type} />
    </TaskMeta>
  </TaskCard>
);
